import { confirmPrelaunchStudios } from '../../../api/prelaunchOrganizationFormsApi'
import { getDateTime } from '../../../helpers/utils'
import AuthPermission from '../../../high-order-components/auth-permission'
import translate from '../../../i18n'
import {
  IPrelaunchStudio,
  IPrelaunchStudioTranslation,
  PrelaunchConfirmationStatusEnum,
} from '../../../pages/prelaunch-organization-forms-container/share-types'
import { PermissionsEnum } from '../../../share-types'
import LinkButton from '../../link-button/link-button'
import PrelaunchConfirmModal from '../prelaunch-confirm-modal/prelaunch-confirm-modal'
import { Button, notification, Space } from 'antd'
import { Typography } from 'antd'
import Table, { ColumnsType } from 'antd/lib/table'
import { useState } from 'react'

const { Title } = Typography

interface Iprops {
  prelaunchOrganizationId?: string
  prelaunchStudios: IPrelaunchStudio[]
}
const PrelaunchStudiosTable = ({ prelaunchStudios, prelaunchOrganizationId }: Iprops) => {
  const [open, setOpen] = useState<boolean>(false)
  const [prelaunchStudio, setPrelaunchStudio] = useState<IPrelaunchStudio | null>(null)

  const handleConfirmButtonClick = (prelaunchStudio: IPrelaunchStudio) => {
    setOpen(true)
    setPrelaunchStudio(prelaunchStudio)
  }

  const handleCloseModal = () => {
    setOpen(false)
    setPrelaunchStudio(null)
  }

  const formatFormName = () => {
    if (prelaunchStudio) {
      return `【${translate('navBar.prelaunchStudios')}】${prelaunchStudio.studioTranslations.map(t => t.name).join(' / ')}`
    } else {
      return `【${translate('navBar.prelaunchStudios')}】`
    }
  }

  const handleConfirmPrelaunchStudio = () => {
    if (prelaunchStudio) {
      confirmPrelaunchStudios({
        prelaunchStudioIds: [prelaunchStudio.id],
      })
        .then(response => {
          setOpen(false)

          if (response) {
            notification.success({
              message: 'Confirm Success',
            })
            setTimeout(() => window.location.reload(), 1000)
          }
        })

        .catch(err => {
          setOpen(false)

          notification.error({
            title: 'Confirm Failed',
            description: err?.message || translate('networkError'),
          })
        })
    }
  }

  const columns: ColumnsType<IPrelaunchStudio> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a: any, b: any) => a.id - b.id,
      fixed: 'left',
      width: 60,
    },
    {
      title: translate('name'),
      dataIndex: 'studioTranslations',
      key: 'studioTranslatioName',
      render: (studioTranslations: IPrelaunchStudioTranslation[]) => {
        return studioTranslations.map(translation => translation.name).join(', ')
      },
    },
    {
      title: translate('status'),
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: translate('createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt: string | null) => {
        if (createdAt) {
          return <span>{getDateTime(createdAt)}</span>
        }
        return ''
      },
    },
    {
      title: translate('updatedAt'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (updatedAt: string | null) => {
        if (updatedAt) {
          return <span>{getDateTime(updatedAt)}</span>
        }
        return ''
      },
    },
    {
      title: translate('tableActionColumn'),
      key: 'action',
      render: (record: IPrelaunchStudio) => {
        return (
          <Space>
            <LinkButton
              to={`/prelaunch-organization-forms/${prelaunchOrganizationId}/studios/${record.id}`}
            >
              {translate('view')}
            </LinkButton>

            <AuthPermission permission={PermissionsEnum.PRELAUNCH_ORGANIZATION_FORMS_WRITE}>
              <LinkButton
                disabled={record.status == PrelaunchConfirmationStatusEnum.CONFIRMED}
                to={`/prelaunch-organization-forms/${prelaunchOrganizationId}/studios/${record.id}/edit`}
              >
                {translate('edit')}
              </LinkButton>
            </AuthPermission>

            <AuthPermission permission={PermissionsEnum.PRELAUNCH_ORGANIZATION_FORMS_WRITE}>
              {record.status == PrelaunchConfirmationStatusEnum.CONFIRMED ? (
                <Button type="link" disabled={true}>
                  {translate('prelaunchOrganizationForms.confirmed')}
                </Button>
              ) : (
                <Button type="link" onClick={() => handleConfirmButtonClick(record)}>
                  {translate('prelaunchOrganizationForms.confirm')}
                </Button>
              )}
            </AuthPermission>
          </Space>
        )
      },
    },
  ]

  return (
    <>
      <Title level={5}>{translate('navBar.prelaunchStudios')}</Title>
      <Table
        rowKey={record => record.id}
        columns={columns}
        dataSource={prelaunchStudios}
        pagination={false}
      />

      <PrelaunchConfirmModal
        open={open}
        formName={formatFormName()}
        handleCancel={handleCloseModal}
        handleConfirm={handleConfirmPrelaunchStudio}
      />
    </>
  )
}

export default PrelaunchStudiosTable
